const getExtensionByType = (type) => ({
  'image/jpeg': '.jpg',
  'image/gif': '.gif',
  'image/png': '.png',
}[type]);

const createFileName = ({ name, type }) => name
  || `${Date.now()}${getExtensionByType(type)}`;

/** Converte um payload em formatos específicos
 *  para diferentes tipos de requisição. */
class BodyParser {
  constructor(data) {
    this.data = typeof data === 'string' ? JSON.parse(data) : data;
  }

  /**
   * Converte o objeto em string de dados.
   * @returns string
   */
  toJSONString() {
    if (!this.data || typeof this.data !== 'object') {
      return '';
    }
    return JSON.stringify(this.data);
  }

  /**
   * Verifica se o objeto é um FormData antes de converter em string.
   */
  toPayload() {
    if (this.data instanceof FormData) {
      return this.data;
    }
    return this.toJSONString();
  }

  /**
   * Converte o objeto para uma url query string.
   * @returns string
   */
  toQueryString() {
    if (!this.data || typeof this.data !== 'object') {
      return '';
    }
    return Object
      .entries(this.data)
      .map((entry) => entry.map(encodeURIComponent).join('='))
      .join('&');
  }

  /**
   * Transforma um array em FormData.
   */
  toFormData() {
    const formdata = new FormData();
    if (!this.data || !(this.data instanceof Array)) {
      return formdata;
    }
    this.data.forEach((file) => formdata
      .append('upload', BodyParser.createUploadFile(file)));
    return formdata;
  }

  // Caso dê algum problema, verificar o fire.uri,

  static createUploadFile(file) {
    return ({
      ...file,
      name: createFileName(file),
      uri: file.uri,
    });
  }
}

export default BodyParser;
